"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IntentModal;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intentForm = _interopRequireDefault(require("./intent-form"));
var _intentThankYouPage = _interopRequireDefault(require("./intent-thank-you-page"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const chatWidgetZIndex = 108000;
function IntentModal({
  eid,
  submitEid,
  size = 'small',
  text,
  _name,
  width = 'auto',
  design = 'primary',
  onClose = () => {},
  disabled,
  complete: defaultComplete,
  inverted = false,
  partial,
  shrinkOn,
  ariaLabel,
  modalOpen = false,
  hideButton = false,
  sections = [],
  submitText = '',
  thankYouPage,
  ...modalProps
}) {
  const [visible, setVisibility] = (0, _react.useState)(modalOpen);
  const [complete, setComplete] = (0, _react.useState)(defaultComplete || false);
  (0, _react.useEffect)(() => {
    if (modalOpen && !visible) {
      setVisibility(modalOpen);
    }
  }, [modalOpen, visible]);
  const handleButtonClick = event => {
    event?.preventDefault && event.preventDefault();
    setVisibility(!visible);
  };
  const handleClose = () => {
    setVisibility(false);
    setComplete(false);
    onClose();
  };
  const handleSubmit = () => {
    setComplete(true);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideButton && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    _name: _name,
    text: text,
    size: size,
    width: width,
    design: design,
    "data-cy": "intent-modal-button",
    onClick: handleButtonClick,
    "data-eid": eid,
    disabled: disabled,
    "aria-label": ariaLabel,
    shrinkOn: shrinkOn,
    partial: partial || (inverted ? 'dark1' : '')
  }), visible && /*#__PURE__*/_react.default.createElement(_modal.default, (0, _extends2.default)({
    id: 'intent-modal',
    "data-cy": "intent-modal",
    onClose: handleClose,
    focusLock: false
  }, modalProps), /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.ModalPatch, {
    maxKnownZIndex: chatWidgetZIndex
  }), complete ? /*#__PURE__*/_react.default.createElement(_intentThankYouPage.default, thankYouPage) : /*#__PURE__*/_react.default.createElement(_intentForm.default, {
    sections: sections,
    submitText: submitText,
    submitEid: submitEid,
    onSubmit: handleSubmit
  })));
}
IntentModal.propTypes = {
  eid: _propTypes.default.string,
  submitEid: _propTypes.default.string,
  text: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'default']),
  width: _propTypes.default.oneOf(['auto', 'full']),
  shrinkOn: _propTypes.default.oneOf(['mobile', 'tablet']),
  _name: _propTypes.default.string,
  design: _propTypes.default.oneOf(['inline', 'primary', 'secondary']),
  onClose: _propTypes.default.func,
  inverted: _propTypes.default.bool,
  partial: _propTypes.default.string,
  complete: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  ariaLabel: _propTypes.default.string,
  modalOpen: _propTypes.default.bool,
  hideButton: _propTypes.default.bool,
  sections: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.oneOf(['small', 'large']),
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      eid: _propTypes.default.string,
      icon: _propTypes.default.string,
      text: _propTypes.default.string
    })),
    heading: _propTypes.default.string,
    description: _propTypes.default.string
  })),
  submitText: _propTypes.default.string,
  thankYouPage: _propTypes.default.shape(_intentThankYouPage.default.propTypes),
  ..._modal.default.propTypes
};